import { Button, Text } from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'
import React, { useState } from 'react'
import { ConfirmationModal } from '../util/ConfirmationModal'

const ConfirmModalContent: React.FC = () => {
  const t = useT()

  return (
    <>
      <Text tag="p" className="vd-mb5">
        {t('Resetting your data deletes:')}
      </Text>
      <ul className="wr-bulleted-list vd-mb5 vd-pl5 vd-pr5">
        <li>
          {t('The sale you’re currently working on', {
            _context: 'Reset data warning bullet list',
          })}
        </li>
        <li>
          {t('Any completed sales that haven’t yet been saved to our servers', {
            _context: 'Reset data warning bullet list',
          })}
        </li>
        <li>
          {t(
            'The copy of your Web Register data saved in your browser (we’ll ' +
              're-sync this with the latest version)',
            { _context: 'Reset data warning bullet list' }
          )}
        </li>
      </ul>
      <Text tag="p">
        <b>
          {t(
            'Before resetting your data, check your sales history to make ' +
              'sure your most recent sales have been saved. Do not reset data if they do not appear.'
          )}
        </b>
      </Text>
    </>
  )
}

interface Props {
  onConfirm: () => void
  disabled?: boolean
}

export const ResetData: React.FC<Props> = ({ onConfirm, disabled = false }) => {
  const t = useT()
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <>
      <Button
        variant="no"
        onClick={() => setIsModalOpen(true)}
        disabled={disabled}
        data-track="reset-data"
      >
        {t('Reset data', { _context: 'Button' })}
      </Button>
      {isModalOpen && (
        <ConfirmationModal
          header={t('Are you sure you want to reset data?', {
            _context: 'Modal header',
          })}
          content={<ConfirmModalContent />}
          confirmButtonLabel={t('Reset data', { _context: 'Button' })}
          cancelButtonLabel={t('Cancel', { _context: 'Button' })}
          onClose={() => setIsModalOpen(false)}
          onConfirm={onConfirm}
        />
      )}
    </>
  )
}
